import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Header } from "../components/layout/SiteChrome";
import { useSell, sellStore } from "../store/sellStore";
import { request } from "../services/api";

export default function PricePage() {
  const sell = useSell();
  const nav  = useNavigate();
  const [brandName, setBrandName] = React.useState("");

  useEffect(() => {
    if (!sell.brandId || !sell.product) {
      nav("/");
    }
  }, [sell.brandId, sell.product, nav]);

  useEffect(() => {
    if (sell.brandId) {
      request('/nodes').then(data => {
        const nodes = data.nodes || []
        const b = nodes.find((n: any) => n._id === sell.brandId);
        if (b) setBrandName(b.name);
      }).catch(console.error);
    }
  }, [sell.brandId]);

  if (!sell.brandId || !sell.product) return null;

  const model  = sell.product;
  const rawPrice = sell.finalPrice;
  const finalPrice = typeof rawPrice === "number" && !isNaN(rawPrice)
    ? rawPrice
    : Number(model?.basePrice || 0);

  const name   = `${brandName} ${model?.name || ""}`.trim();
  const basePriceForPercentage = Number(sell.algoBasePrice || model?.basePrice || 1);
  const pctStr = basePriceForPercentage > 0 ? Math.round((finalPrice / basePriceForPercentage) * 100) : 0;

  // Quote validation - if price is <= 200, show rejection message
  if (finalPrice <= 200) {
    return (
      <div className="page-bg">
        <Header />
        <div style={{ maxWidth: 560, margin: "0 auto", padding: "32px 16px 72px" }}>
          <button onClick={() => nav(-1)} style={{ background: "none", border: "none", color: "var(--text2)", fontSize: 13, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 5, fontFamily: "var(--font-body)", transition: "color 0.2s" }}
            onMouseEnter={e => (e.currentTarget.style.color = "var(--brand)")}
            onMouseLeave={e => (e.currentTarget.style.color = "var(--text2)")}>
            ← Revise answers
          </button>

          {/* Rejection card */}
          <div style={{
            background: "linear-gradient(145deg, #1a1a2e 0%, #16213e 40%, #0f3460 100%)",
            borderRadius: 24, padding: "44px 28px 36px", textAlign: "center", marginBottom: 24,
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)", position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", top: -50, right: -50, width: 180, height: 180, borderRadius: "50%", background: "rgba(239,68,68,0.12)", pointerEvents: "none" }} />
            <div style={{ position: "absolute", bottom: -40, left: -40, width: 140, height: 140, borderRadius: "50%", background: "rgba(239,68,68,0.1)", pointerEvents: "none" }} />

            <div style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              background: "rgba(239,68,68,0.2)", border: "1px solid rgba(239,68,68,0.3)",
              borderRadius: 20, padding: "5px 14px", marginBottom: 20,
            }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#ef4444", boxShadow: "0 0 8px rgba(239,68,68,0.6)" }} />
              <span style={{ fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.85)", letterSpacing: "0.04em" }}>UNABLE TO PURCHASE</span>
            </div>

            <div style={{ fontSize: 48, marginBottom: 16 }}>😔</div>
            
            <div style={{
              fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(24px,6vw,32px)",
              color: "#fff", letterSpacing: "-0.5px", lineHeight: 1.2, marginBottom: 12,
            }}>
              We can't purchase your product
            </div>
            
            <div style={{ fontSize: 15, color: "rgba(255,255,255,0.6)", marginBottom: 8, fontWeight: 500 }}>
              for your <strong style={{ color: "#fff" }}>{name}</strong>
            </div>
            
            <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginBottom: 24, lineHeight: 1.6 }}>
              Based on the condition details you provided, the quoted price is too low for us to proceed with the purchase.
              <br /><br />
              You can try revising your answers or check back later.
            </div>
          </div>

          {/* Action buttons */}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <button onClick={() => nav(-1)} style={{
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              width: "100%", borderRadius: 16, border: "none",
              background: "linear-gradient(135deg, var(--brand), var(--brand-dark))",
              padding: "18px", fontFamily: "var(--font-display)", fontSize: 17, fontWeight: 800,
              color: "#fff", cursor: "pointer", textDecoration: "none",
              boxShadow: "0 8px 28px rgba(255,107,53,0.4)", transition: "all 0.2s",
            }}
              onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.transform = "translateY(-2px)"; el.style.boxShadow = "0 12px 36px rgba(255,107,53,0.5)"; }}
              onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.transform = ""; el.style.boxShadow = "0 8px 28px rgba(255,107,53,0.4)"; }}>
              Revise My Answers
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </button>
            <button onClick={() => { sellStore.reset(); nav("/"); }}
              style={{
                width: "100%", borderRadius: 14, border: "1.5px solid var(--border)", background: "var(--surface)",
                padding: "14px", fontFamily: "var(--font-body)", fontSize: 14, fontWeight: 500,
                color: "var(--text2)", cursor: "pointer", transition: "all 0.2s",
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--danger)"; e.currentTarget.style.color = "var(--danger)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.color = "var(--text2)"; }}>
              Start Over
            </button>
          </div>
        </div>
      </div>
    );
  }

  const conditionSummary = sell.conditionSummary?.length
    ? sell.conditionSummary.map(c => ({ label: c.question, value: c.answer }))
    : [
        sell.answers.screen    && { label: "Screen", value: (sell.answers.screen || []).join(', ') },
        sell.answers.battery   && { label: "Battery", value: (sell.answers.battery || []).join(', ') },
        sell.answers.physical  && { label: "Physical", value: (sell.answers.physical || []).join(', ') },
        sell.answers.accessories && { label: "Accessories", value: (sell.answers.accessories || []).join(', ') },
      ].filter(Boolean) as { label: string; value: string }[];

  return (
    <div className="page-bg">
      <Header />
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "32px 16px 72px" }}>

        <button onClick={() => nav(-1)} style={{ background: "none", border: "none", color: "var(--text2)", fontSize: 13, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 5, fontFamily: "var(--font-body)", transition: "color 0.2s" }}
          onMouseEnter={e => (e.currentTarget.style.color = "var(--brand)")}
          onMouseLeave={e => (e.currentTarget.style.color = "var(--text2)")}>
          ← Revise answers
        </button>

        {/* Hero price card */}
        <div style={{
          background: "linear-gradient(145deg, #0f172a 0%, #1e293b 40%, #0f766e 100%)",
          borderRadius: 24, padding: "44px 28px 36px", textAlign: "center", marginBottom: 24,
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)", position: "relative", overflow: "hidden",
        }}>
          {/* Decorative circles */}
          <div style={{ position: "absolute", top: -50, right: -50, width: 180, height: 180, borderRadius: "50%", background: "rgba(29,158,117,0.12)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: -40, left: -40, width: 140, height: 140, borderRadius: "50%", background: "rgba(99,102,241,0.1)", pointerEvents: "none" }} />

          <div style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            background: "rgba(29,158,117,0.2)", border: "1px solid rgba(29,158,117,0.3)",
            borderRadius: 20, padding: "5px 14px", marginBottom: 20,
          }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#34d399", boxShadow: "0 0 8px rgba(52,211,153,0.6)" }} />
            <span style={{ fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.85)", letterSpacing: "0.04em" }}>BEST OFFER</span>
          </div>

          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", fontWeight: 500, marginBottom: 4 }}>We'll pay you</div>
          <div style={{
            fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(48px,12vw,72px)",
            color: "#fff", letterSpacing: "-2px", lineHeight: 1, marginBottom: 8,
          }}>
            ₹{finalPrice.toLocaleString("en-IN")}
          </div>
          <div style={{ fontSize: 15, color: "rgba(255,255,255,0.6)", marginBottom: 20, fontWeight: 500 }}>
            for your <strong style={{ color: "#fff" }}>{name}</strong>
          </div>

          <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
            {pctStr && (
              <div style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 20, padding: "6px 14px" }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.8)" }}>{pctStr}% of market value</span>
              </div>
            )}
            <div style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 20, padding: "6px 14px" }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.8)" }}>Price locked for 24h</span>
            </div>
          </div>
        </div>

        {/* Condition summary */}
        {conditionSummary.length > 0 && (
          <div style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 18, padding: "20px 22px", marginBottom: 16, boxShadow: "var(--shadow-sm)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: "var(--indigo-light)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "var(--indigo)" }}>✓</div>
              <span style={{ fontWeight: 700, fontSize: 14, color: "var(--text)" }}>Device Condition</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}>
              {conditionSummary.map((c, i) => (
                <div key={i} style={{ background: "var(--bg)", borderRadius: 10, padding: "10px 14px", border: "1px solid var(--border)" }}>
                  <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 2 }}>{c.label}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", textTransform: "capitalize" }}>{c.value}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Guarantees */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10, marginBottom: 24 }}>
          {[
            { icon: "🚚", title: "Free Pickup", sub: "Doorstep service", color: "#dbeafe", stroke: "#3b82f6" },
            { icon: "⚡", title: "Instant Pay", sub: "Cash / NEFT / UPI", color: "#fef3c7", stroke: "#f59e0b" },
            { icon: "🛡️", title: "Best Price", sub: "Price match guarantee", color: "#dcfce7", stroke: "#22c55e" },
            { icon: "🔒", title: "Safe & Secure", sub: "KYC verified process", color: "#f3e8ff", stroke: "#a855f7" },
          ].map((g, i) => (
            <div key={i} style={{
              background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 14,
              padding: "16px 14px", textAlign: "center", transition: "all 0.2s",
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--brand)"; e.currentTarget.style.boxShadow = "var(--shadow-md)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.boxShadow = "none"; }}>
              <div style={{ width: 40, height: 40, borderRadius: 12, background: g.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, margin: "0 auto 10px" }}>{g.icon}</div>
              <div style={{ fontWeight: 700, fontSize: 13, color: "var(--text)", marginBottom: 2 }}>{g.title}</div>
              <div style={{ fontSize: 11, color: "var(--text3)" }}>{g.sub}</div>
            </div>
          ))}
        </div>

        {/* How it works */}
        <div style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 18, padding: "20px 22px", marginBottom: 24, boxShadow: "var(--shadow-sm)" }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: "var(--text)", marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 16 }}>📋</span> How payment works
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {[
              { n: "1", title: "Technician visits your home", sub: "Free & on-time", color: "var(--indigo)" },
              { n: "2", title: "Device inspected on-site", sub: "Quick 5-min check", color: "var(--brand)" },
              { n: "3", title: "Final price confirmed", sub: "±10% of quoted price", color: "var(--indigo)" },
              { n: "4", title: "Payment transferred", sub: "Cash, NEFT, or UPI", color: "var(--brand)" },
            ].map((s, i, arr) => (
              <div key={s.n} style={{ display: "flex", alignItems: "flex-start", gap: 14, padding: "14px 0", borderBottom: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
                <div style={{
                  width: 30, height: 30, borderRadius: 10, background: `${s.color}15`, border: `1.5px solid ${s.color}30`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 12, fontWeight: 800, color: s.color, flexShrink: 0, fontFamily: "var(--font-display)",
                }}>{s.n}</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", marginBottom: 2 }}>{s.title}</div>
                  <div style={{ fontSize: 12, color: "var(--text3)" }}>{s.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA buttons */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Link to="/schedule" style={{
            display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
            width: "100%", borderRadius: 16, border: "none",
            background: "linear-gradient(135deg, var(--brand), var(--brand-dark))",
            padding: "18px", fontFamily: "var(--font-display)", fontSize: 17, fontWeight: 800,
            color: "#fff", cursor: "pointer", textDecoration: "none",
            boxShadow: "0 8px 28px rgba(255,107,53,0.4)", transition: "all 0.2s",
          }}
            onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.transform = "translateY(-2px)"; el.style.boxShadow = "0 12px 36px rgba(255,107,53,0.5)"; }}
            onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.transform = ""; el.style.boxShadow = "0 8px 28px rgba(255,107,53,0.4)"; }}>
            Accept & Schedule Pickup
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </Link>
          <button onClick={() => { sellStore.reset(); nav("/"); }}
            style={{
              width: "100%", borderRadius: 14, border: "1.5px solid var(--border)", background: "var(--surface)",
              padding: "14px", fontFamily: "var(--font-body)", fontSize: 14, fontWeight: 500,
              color: "var(--text2)", cursor: "pointer", transition: "all 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--danger)"; e.currentTarget.style.color = "var(--danger)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.color = "var(--text2)"; }}>
            Start Over
          </button>
        </div>

        <p style={{ textAlign: "center", fontSize: 12, color: "var(--text3)", marginTop: 20, lineHeight: 1.6 }}>
          Final price confirmed after physical inspection · Free cancellation anytime
        </p>
      </div>
    </div>
  );
}
